import './style.sass';
import { ReactSVG } from 'react-svg';
import React, { useEffect } from 'react';
import closeIcon from 'assets/img/icons/close-icon.svg';
import { createPortal } from 'react-dom';
import { Modal } from '../common/Modal';
import { observer } from 'mobx-react-lite';
import { CampaignAssetForm } from '../CampaignAssetForm';
import { CampaignInnerPageViewModel } from 'app/viewModels/pages/CampaignInnerPageViewModel';

type Props = {
    model: CampaignInnerPageViewModel,
};

export const UpdateCampaignSong = observer(({ model }: Props) => {
    const {
        campaignModel,
        onChangeLink,
        onSubmitUpdateSongInfo,
        onDeleteAssetLink,
        searchedSong,
        checkboxIsNotReleaseModel,
        songModalModel,
        isLoading,
    } = model;

    const {
        assetLink,
        releaseDate,
        authorName,
        assetName,
    } = campaignModel;
    const isTrackReleased = !!assetLink;

    const initialValues = {
        link: assetLink || '',
    };

    const initialValuesArtistInfo = {
        releaseDate: releaseDate || '',
        artistName: authorName || '',
        songName: assetName || '',
    };

    const onCloseModal = () => {
        songModalModel.setFalse();
    };

    useEffect(() => {
        if (!isTrackReleased) {
            checkboxIsNotReleaseModel.setTrue();
        } else {
            checkboxIsNotReleaseModel.setFalse();
        }
    }, [isTrackReleased, checkboxIsNotReleaseModel]);

    if (!songModalModel.value) {
        return null;
    }

    return (
        createPortal(
            <Modal onClose={onCloseModal}>
                <div className="update-campaign-song">
                    <div className="update-campaign-song__close-btn" onClick={onCloseModal}>
                        <ReactSVG src={closeIcon}/>
                    </div>

                    <h1 className="title-h1 update-campaign-song__title">Edit song information</h1>

                    <CampaignAssetForm
                        isTrackReleased={!checkboxIsNotReleaseModel.value}
                        defaultInitialValues={initialValues}
                        artistInfoInitialvalues={initialValuesArtistInfo}
                        onSubmit={onSubmitUpdateSongInfo}
                        onChangeLink={onChangeLink}
                        searchedSong={searchedSong}
                        checkboxModel={checkboxIsNotReleaseModel}
                        submitBtnText="Save changes"
                        isCancelBtnActive
                        onClickCancelBtn={onCloseModal}
                        withDeleteBtn
                        isDeleteBtnActive={!!assetLink}
                        onClickDelete={onDeleteAssetLink}
                        isLoading={isLoading}
                    />
                </div>
            </Modal>,
            document.body,
        ) as React.ReactNode
    );
});
